import { render } from "./VueCheck.vue?vue&type=template&id=2c887e6a&scoped=true"
import script from "./VueCheck.vue?vue&type=script&lang=js"
export * from "./VueCheck.vue?vue&type=script&lang=js"

import "./VueCheck.vue?vue&type=style&index=0&id=2c887e6a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c887e6a"]])

export default __exports__